export default function animationFrame(cb) {
  requestAnimationFrame ? requestAnimationFrame(cb) : setTimeout(cb, 15);
};
